// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SmallBenefits_wrapper__a02b6","points":"SmallBenefits_points__aa41f","icon":"SmallBenefits_icon__23e90"};